<template>
  <v-dialog v-model="dialog" width="1100px" :fullscreen="$vuetify.breakpoint.smAndDown" scrollable>
    <v-card>
      <v-card-title class="primary white--text"
        ><v-toolbar-title>Xem chi tiết</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-card-text :class="{ 'doc-type': !isPdf }">
        <PdfPreview v-if="isPdf" :open-count="openCount" :url="(file && file.url) || ''" @download="openLink" />
        <VueDocPreview type="office" :value="file && file.url" v-else />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-space-between pa-4">
        <v-btn class="px-6" outlined light depressed @click="openLink">Tải xuống</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" width="100px" class="elevation-0" @click="cancel">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import VueDocPreview from 'vue-doc-preview'
import PdfPreview from './PdfPreview.vue'

export default {
  components: {
    VueDocPreview,
    PdfPreview
  },
  props: {
    state: {
      type: Boolean,
      default: () => false
    },
    file: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dialog: false,
      isPdf: false,
      openCount: 0
    }
  },

  methods: {
    cancel() {
      this.dialog = false
    },
    openLink() {
      if (this.file.url) window.open(this.file.url, '_blank')
    }
  },
  watch: {
    state() {
      this.dialog = true
      this.openCount += 1
      const name = this.file && this.file.name
      this.isPdf = !!name && name.toLowerCase().endsWith('.pdf')
    }
  }
}
</script>
<style scoped>
.doc-type {
  overflow: hidden !important;
}
</style>
